import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getSocialMediaSuggestions(params) {
  const response = await axiosClient.get(`/admin/social-media/suggestions${toQueryString(params)}`);
  return response.data;
}

export async function getSocialMediaPlan(params) {
  const response = await axiosClient.get(`/admin/social-media/plan${toQueryString(params)}`);
  return response.data;
}

export async function createSocialMediaPlanItem(data) {
  const response = await axiosClient.post(`/admin/social-media/plan`, data);
  return response.data;
}

export async function updateSocialMediaPlanItem(id, data) {
  const response = await axiosClient.put(`/admin/social-media/plan/${id}`, data);
  return response.data;
}

export async function deleteSocialMediaPlanItem(id) {
  await axiosClient.delete(`/admin/social-media/plan/${id}`);
}
